<template>
  <card class="pt-3 pb-3">
    <list
      :itemLink="itemLink"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :searchDisable="true"
      :isAdd="true"
      :fields="fields"
      @change="change"
      :setLink="setLink"
    />
      <!-- :functions="functions" -->
  </card>
</template>

<script>
import List from "../components/List";

export default {
  name: "draws-page",
  components: {
    List,
  },
  data() {
    return {
      // functions: [{ id: 1, title: "Установить группу" }],
      //end callback data
      /**Меняю ссылки на модель */
      modalCreate: "draw",
      removeLink: "news/remove",
      cardLink: "new",
      itemLink: "admin/news",
      setLink: "admin/news/create",
      /**Табличные филды */
      fields: [
        {
          label: "Тема письма",
          key: "subject",
          type: "text",
        },
        {
          label: "Заголовок",
          key: "title",
          type: "numeric",
        },
      ],
      columns: [
         {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
              detail: true,
        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
        
        },
  
       
        {
          key: "created_at",
          title: "Дата создания",
          checkbox: false,
          control: false,
          align: "right",
        },
      ],
      value: null,
    };
  },
  methods: {
    changeFunction(val) {
      if (val == 1) {
        this.$store.dispatch("openModal", {
          model: "group",
          route: "admin/clients/relate/group",
        });

        this.$store.dispatch("selectValue", this.value);
      }
    },
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
};
</script>
<style>
</style>
